import { AbstractQuery } from 'src/models/query';

export class GetTheCountOfAllUnfinishedItemsForTheUserQuery extends AbstractQuery {
	cacheable = false;
	ignoreCachedResult = true;
	name = 'IFS_Desktop_Query_Queries_GetTheCountOfAllUnfinishedItemsForTheUserQuery';
	parameters = [{ statusRed: 'unseen' }, { statusYellow: 'seen' }];
	sort = [];
}

export class GetAllMenuItemsForTheUserQuery extends AbstractQuery {
	cacheable = false;
	ignoreCachedResult = true;
	name = 'IFS_Menu_Query_Queries_GetAllMenuItemsForTheUserQuery';
	parameters = [];
	sort = [];
}
